module.exports = __webpack_public_path__ + "static/media/trip-my@2x.72c67c93.png";